<template>
  <div>
    <h1>Customers</h1>
    <ul>
      <li v-for="(events, customerID) in customers" :key="customerID">
        <h3>{{ customerID }}:</h3>
        <ul>
          <li v-for="(_, eventID) in events" :key="eventID">
            <router-link
              :to="{ name: 'event-list', params: { hotel: eventID, customerID: customerID } }"
            >
              {{ eventID }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { db, auth } from "@/firebase";

export default {
  data() {
    return {
      customers: null,
    };
  },
  async beforeRouteLeave(to, _, next) {
    await db.ref(`users/${auth.currentUser.uid}/customerid`).set(to.params.customerID);
    next();
  },
  created() {
    db.ref('hotelsList')
      .once('value')
      .then( snapshot => {
        this.customers = snapshot.val();
      })
  },
};
</script>
<style scoped> 
div {
  margin-left: 10px;
}
</style>
